// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import ContentWrapper from 'Component/ContentWrapper';
import Html from "Component/Html";
import './NewEvents.style';
import NewEventsBlogPostCard from './NewEventBlogPostCard';
import Field from "Component/Field/Field.component";
import Loader from 'Component/Loader';
import { BLOG_CATEGORY_LISTING } from "../../../route/CategoryListing/CategoryListing.config";

export class NewEvents extends PureComponent {
    state = {
        selectedMonthItems: []
    }

    componentDidMount() {
        this.updateMeta();
        this.setHeaderState();
        this.updateBreadcrumbs();
    }

    componentDidUpdate(prevProps) {
        const { posts: { items }, isLoaded, selectedMonth, isBetweenDates } = this.props;
        const { selectedMonth: prevSelectedMonth } = prevProps;
        const { selectedMonthItems } = this.state;

        if (isLoaded && items.length) {
            let tempSelectedMonthItems = items.filter((post) => {
                const { event_start_date, event_end_date, publish_time } = post;
                if (selectedMonth === 0) return post;
                if (!event_start_date && !event_end_date)
                    return isBetweenDates(publish_time, publish_time, selectedMonth)
                if (event_start_date && !event_end_date)
                    return isBetweenDates(event_start_date, event_start_date, selectedMonth)
                if (!event_start_date && event_end_date)
                    return isBetweenDates(event_end_date, event_end_date, selectedMonth)
                if (event_start_date && event_end_date)
                    return isBetweenDates(event_start_date, event_end_date, selectedMonth)
                return null;
            });
            if ((prevSelectedMonth !== selectedMonth) || (!prevSelectedMonth && selectedMonth === 0 && !selectedMonthItems.length)) {
                return this.setState({ selectedMonthItems: tempSelectedMonthItems })
            }
        }
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs, mfblog_permalink_route, categoryObject: { title }, blog_title } = this.props;
        const breadcrumbs = [
            {
                url: window.location.pathname,
                name: title
            },
            {
                url: `/${mfblog_permalink_route}`,
                name: blog_title
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    updateMeta() {
        const { updateMeta, redirect_code_previous, categoryObject: _category } = this.props;

        updateMeta({
            title: _category.title,
            meta_title: _category.meta_title,
            meta_keywords: _category.meta_keywords,
            meta_description: _category.meta_description,
            canonical_url: window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous
        });
    }

    getCanonicalUrl() {
        return window.location.href;
    }

    setHeaderState() {
        const { setHeaderState, history } = this.props;
        setHeaderState({
            name: BLOG_CATEGORY_LISTING,
            title: 'Blog',
            onBackClick: () => history.goBack()
        });
    }

    renderTitle() {
        const { categoryObject: { title } } = this.props;

        return (
            <h1 block="CategoryListing" elem="Title">
                {title}
            </h1>
        );
    }

    getCategoryDescription() {
        const { categoryObject: { content } } = this.props;

        if (!content)
            return null;

        return (
            <div className="CategoryListing-Description">
                <Html content={content} />
            </div>
        );
    }

    renderGridDropDown() {
        const { onDropDownChange, selectedMonth, month_sort_options, isLoaded } = this.props;
        if (!month_sort_options) return null;

        if (isLoaded) {
            return (
                <div className="NewEvents-Grid_filter">
                    <Field
                        type='select'
                        id='selected-month'
                        selectOptions={month_sort_options}
                        noSort={true}
                        onChange={onDropDownChange}
                        placeholder={__('All Events')}
                        value={selectedMonth}
                    />
                </div>
            );
        }
        return null;
    }

    renderGrid() {
        const {
            isLoaded,
            pageSize,
            selectedMonth
        } = this.props;

        const { selectedMonthItems } = this.state;

        if (isLoaded && selectedMonthItems.length) {
            return selectedMonthItems.map(post =>
                <NewEventsBlogPostCard
                    key={post.post_id}
                    block="BlogPostCard"
                    post={post}
                    normalGrid={true}
                    selectedMonth={selectedMonth}
                />
            )
        }

        if (isLoaded) {
            return (
                <span>
                    {__('No posts in this category')}
                </span>
            );
        }

        return Array.from({ length: pageSize }, (_, i) => (
            <NewEventsBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    renderFiltering() {
        return (
            <div className="NewEvents_tabs">
                {this.renderGridDropDown()}
            </div >
        );
    }

    render() {
        const { isLoading } = this.props;
        return (
            <main block="NewEvents">
                <Loader isLoading={isLoading} />
                <ContentWrapper label="NewEvents">
                    <div block="NewEvents" elem="Heading">
                        {this.renderTitle()}
                        {this.renderFiltering()}
                    </div>
                    {this.getCategoryDescription()}
                    < div block="NewEvents" elem="Grid" >
                        {this.renderGrid()}
                    </div >
                </ContentWrapper>
            </main>
        );
    }
}

export default NewEvents;
